module.exports = __webpack_public_path__ + "static/mtfp-d4e89a484bc0b5b4e7d3635343b1de48.svg";